import { render, staticRenderFns } from "./default.vue?vue&type=template&id=044df8cd&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CookiesBanner: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/Cookies/Banner/index.vue').default,CookiesModal: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/Cookies/Modal/index.vue').default})
